import { atom } from "jotai";
import { DeductionDocument, RemittanceItem } from "@/core/entities/deduction";

export enum TabType {
  INFORMATION = "Information",
  ACTIVITY = "Activity",
  CONVERSATIONS = "Conversations",
}

interface DrawerInfo {
  nextPrevEnabled: boolean;
  remittanceItemId: number;
  remittanceItem: RemittanceItem;
  checkNumber: string;
  invoiceNumber: string;
  isRemittanceItemsPage: boolean;
  purchaserKey: string;
  isDeductionIncomplete: boolean;
  isManuallyUploaded: boolean;
}

export interface DrawerState {
  drawerInfo: DrawerInfo | null;
  isDrawerOpen: boolean;
  isDrawerModal: boolean;
  isFirstItem: boolean;
  isLastItem: boolean;
  isNextPrevEnabled: boolean;
  viewerDocuments: DeductionDocument[] | null;
  isDocumentViewerOpen: boolean;
  hasAnyUnsavedChanges: boolean;
  currentExpandedDeductionId: number | null;
}

const initialState: DrawerState = {
  drawerInfo: null,
  isDrawerOpen: false,
  isDrawerModal: true,
  isFirstItem: false,
  isLastItem: false,
  isNextPrevEnabled: false,
  viewerDocuments: null,
  isDocumentViewerOpen: false,
  hasAnyUnsavedChanges: false,
  currentExpandedDeductionId: null,
};

export const selectedTabAtom = atom<TabType | null>(null);

// Base atoms
export const drawerAtom = atom<DrawerState>(initialState);

// Derived atoms for specific states
export const drawerInfoAtom = atom(get => get(drawerAtom).drawerInfo);
export const isDrawerOpenAtom = atom(get => get(drawerAtom).isDrawerOpen);
export const isDrawerModalAtom = atom(get => get(drawerAtom).isDrawerModal);
export const isFirstItemAtom = atom(get => get(drawerAtom).isFirstItem);
export const isLastItemAtom = atom(get => get(drawerAtom).isLastItem);
export const isNextPrevEnabledAtom = atom(get => get(drawerAtom).isNextPrevEnabled);
export const viewerDocumentAtom = atom(get => get(drawerAtom).viewerDocuments);
export const isDocumentViewerOpenAtom = atom(get => get(drawerAtom).isDocumentViewerOpen);
export const hasAnyUnsavedChangesAtom = atom(get => get(drawerAtom).hasAnyUnsavedChanges);
export const currentExpandedDeductionIdAtom = atom(get => get(drawerAtom).currentExpandedDeductionId);